import { UpsellServiceEnum } from '.spec/self-care/tsTypes';
import { addMonths, format } from 'date-fns';

import type { UpsellServiceAvailableOffer } from '@types/upsellServiceAvailableOffer';

import { MONTH_KEY_FORMAT } from './types';

export const monthsAgoKey = (now: Date, months: number): string =>
	format(addMonths(now, -months), MONTH_KEY_FORMAT);

export const monthOfIsoDate = (isoDate: string): string | null => {
	const date = new Date(isoDate);
	return Number.isNaN(date.getTime()) ? null : format(date, MONTH_KEY_FORMAT);
};

export const purchaseMonth = (offer: UpsellServiceAvailableOffer): string =>
	offer.purchaseDate.slice(0, 7);

export const hasExtendedWarranty = (offer: UpsellServiceAvailableOffer): boolean =>
	offer.availableServices.some(({ service }) => service === UpsellServiceEnum.EXTENDED_WARRANTY);
